import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
const PurchaseRegisterComponent = loadable(
  () => import("../../components/CBMSReports/PurchaseReturnRegister")
);

const PurchaseReturnRegister = () => {
  return (
    <>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Purchase Return Register
        </h1>
      </div>
      <PurchaseRegisterComponent />
    </>
  );
};

export default PurchaseReturnRegister;
